import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { clientAPI } from "../api/client";

const NUMBER_NFT_PER_PAGE = 5;
const queryKey = "timekeeping";

async function fetchTimeKeeping(currentPage, search) {
  try {
    const options = {
      limit: NUMBER_NFT_PER_PAGE,
      page: currentPage,
    };

    if (search) options.search = search;
    const queryParams = new URLSearchParams(options).toString();
    let data = await clientAPI("get", `/checkin/place/list/?${queryParams}`);
    const totalPages = Math.ceil(data?.pagination?.total / NUMBER_NFT_PER_PAGE);
    const entries = data?.pagination?.total;
    const startEntry =
      (data?.pagination?.page - 1) * data?.pagination?.limit + 1;
    const endEntry = Math.min(
      data?.pagination?.page * data?.pagination?.limit,
      entries,
    );

    const newData = data?.items.map((item, index) => {
      return {
        num: index + 1 + NUMBER_NFT_PER_PAGE * (currentPage - 1),
        status: item?.status,
        code: item?.code,
        identifier: item?.identifier,
        name: item?.name,
        type: ["Nhân viên kinh doanh", "Nhân viên hỗ trợ kinh doanh"],
        start: [item?.timeForSale, item?.timeForSupport],
        end: [item?.lateTimeForSale, item?.lateTimeForSupport],
        blockCheckinTime: item?.blockCheckinTime,
        date: item?.createdAt,
        employeecreate: item?.createdBy ? item.createdBy.fullName : "",
        bssId: item?.bssId || [],
        isQrCode: item?.checkInTypes?.includes("QRCODE") || false,
        edit: {
          id: item._id,
          status: item?.status,
        },
        editData: {
          checkInTypes: item.checkInTypes,
          location: item.location,
          timeForSale: item.timeForSale,
          timeForSupport: item.timeForSupport,
          lateTimeForSale: item.lateTimeForSale,
          lateTimeForSupport: item.lateTimeForSupport,
          blockCheckinTime: item?.blockCheckinTime,
          checkoutTime: item?.checkoutTime,
          saturdayCheckoutTime: item?.saturdayCheckoutTime,
          bssId: item?.bssId || [],
          identifier: item?.identifier,

          checkinMode: item?.checkinMode || "NORMAL",
          checkinSessions: Array.isArray(item?.checkinSessions)
            ? item.checkinSessions
            : [],
        },
      };
    });

    return { data: newData, totalPages, entries, startEntry, endEntry };
  } catch (error) {
    console.error("Error fetching timekeeping data:", error);
    return { data: [], totalPages: 0 };
  }
}

export function useTimeKeeping(search) {
  const [currentPage, setCurrentPage] = useState(1);

  const { data, refetch, isLoading, isRefetching } = useQuery({
    queryKey: [queryKey, currentPage, search],
    queryFn: () => fetchTimeKeeping(currentPage, search),
    refetchOnWindowFocus: false,
    staleTime: 30000,
  });

  const nextPage = () => {
    if (currentPage < data?.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return {
    timekeepingData: data?.data,
    totalPages: data?.totalPages,
    refetch,
    isLoading,
    isRefetching,
    prevPage,
    nextPage,
    setCurrentPage,
    currentPage,
    entries: data?.entries,
    startEntry: data?.startEntry,
    endEntry: data?.endEntry,
  };
}
